// utils/eventBus.js - JAVASCRIPT PURO
class EventBus {
  constructor() {
    this.events = {};  // Oggetto JS
  }

  emit(event, data) {
    if (this.events[event]) {
      this.events[event].forEach(callback => callback(data));  // ForEach JS
    }
  }

  on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  }

  off(event, callback) {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter(cb => cb !== callback);  // Filter JS
  }
}

const eventBus = new EventBus();  // Istanza JS
export default eventBus;